import { render, staticRenderFns } from "./MLC.vue?vue&type=template&id=3531ceb4&scoped=true"
import script from "./MLC.vue?vue&type=script&lang=js"
export * from "./MLC.vue?vue&type=script&lang=js"
import style0 from "./MLC.vue?vue&type=style&index=0&id=3531ceb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3531ceb4",
  null
  
)

export default component.exports